import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { alpha, useTheme } from "@mui/material/styles";
import MDBox from "components/MDBox";
import type { PedidoOperacionalInput } from "interfaces/loja/pedidoOperacional";
import { resolvePedidoOperacional } from "utils/pedidoOperacional";

type PedidoStatusOperacionalCardProps = {
  input: PedidoOperacionalInput;
};

export default function PedidoStatusOperacionalCard({
  input,
}: PedidoStatusOperacionalCardProps) {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const borderSoft =
    mode === "dark" ? alpha("#c8e6c9", 0.45) : alpha("#7cb342", 0.22);

  const o = resolvePedidoOperacional(input);

  const alertas =
    (o.statusFaturamento === "ERRO" ? 1 : 0) +
    (o.statusSeparacao === "DIVERGENCIA" || o.statusSeparacao === "FALTA_ESTOQUE"
      ? 1
      : 0) +
    (o.statusLogistico === "DEVOLVIDO" || o.statusLogistico === "EXTRAVIADO"
      ? 1
      : 0);

  const situacao =
    o.status === "DEVOLUCAO_SOLICITADA"
      ? "Requer atenção"
      : o.status === "CANCELADO" || o.status === "DEVOLVIDO"
        ? "Encerrado"
        : alertas > 0
        ? "Requer atenção"
        : o.status === "ENTREGUE" ||
              (o.tipoEntrega === "ENTREGA" && o.statusLogistico === "ENTREGUE") ||
              o.statusRetirada === "RETIRADO" ||
              o.statusRetirada === "ENTREGUE_NO_EVENTO"
            ? "Concluído"
            : "Em andamento";

  const color =
    situacao === "Requer atenção"
      ? "warning"
      : situacao === "Concluído" || situacao === "Encerrado"
        ? "success"
        : "info";

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        border: `1px solid ${borderSoft}`,
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        height: "100%",
      }}
    >
      <MDBox p={2.5}>
        <Stack spacing={1.5}>
          <Typography variant="button" fontWeight={700} color="primary">
            Status operacional
          </Typography>
          <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
            <Chip label={situacao} size="small" color={color} sx={{ fontWeight: 700 }} />
            {alertas > 0 ? (
              <Typography variant="caption" color="warning.main">
                {alertas} alerta(s) nas etapas
              </Typography>
            ) : (
              <Typography variant="caption" color="text.secondary">
                Visão consolidada das etapas abaixo
              </Typography>
            )}
          </Stack>
        </Stack>
      </MDBox>
    </Card>
  );
}
